interface LoaderProps {
    className?: string;
}

const Loader = (props: LoaderProps) => {
    const {className} = props;

    return <div className={className}>
        <div className="spinner-grow color-blue mx-1" role="status">
            <span className="sr-only">Loading...</span>
        </div>
        <div className="spinner-grow color-green mx-1" role="status">
            <span className="sr-only">Loading...</span>
        </div>
        <div className="spinner-grow color-light-green mx-1" role="status">
            <span className="sr-only">Loading...</span>
        </div>
        <div className="spinner-grow color-orange mx-1" role="status">
            <span className="sr-only">Loading...</span>
        </div>
        <div className="spinner-grow color-coral mx-1" role="status">
            <span className="sr-only">Loading...</span>
        </div>
    </div>
};

export default Loader;